import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';
// Custom components
import * as React from 'react';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ReactPaginate from 'react-paginate';
import { IoSearchOutline } from 'react-icons/io5';
import {
    addAdmin,
    deleteAdmin,
    getAdmin,
    searchAdmin,
    updateAdmin,
} from '../../../redux/actions/Master.action';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { allBranchDetail } from '../../../redux/actions/Files.action';

export default function AdminUser() {
    const [show, setShow] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [branchId, setBranchId] = useState();
    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchDefault, setSearchDefault] = useState({
        page: '',
        search: '',
    });

    const toggle = () => {
        setShow(!show);
    };
    const updateToggle = () => {
        setUpdateModal(!updateModal);
    };
    const deleteToggle = () => {
        setDeleteModal(!deleteModal);
    };

    const dispatch = useDispatch();
    const getProblems = useSelector((state) => state.master);
    const getBranch = useSelector((state) => state.files);



    const initialValues = {
        name: "",
        email: "",
        password: "",
        plainPassword: "",
        branch: "",
        phoneNumber: ""
        // Removed type field as it's static
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        email: Yup.string().required('Email is required'),
        password: Yup.string().required('Password is required'),
        branch: Yup.string().required('Branch is required'),
        phoneNumber: Yup.string().required('Phone Number is required'),
        // Removed type validation
    });

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        plainPassword: "",
        branch: "",
        phoneNumber: ""
        // Removed type from state
    });



    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    };

    const handleAdminDetail = (values, { resetForm }) => {

        dispatch(addAdmin(values, limits)).then(() => {
            toggle();
            resetForm();
        });
    };

    const handleUpadteProblam = (values) => {

        const payload = {
            authId: branchId,
            name: values.name,
            email: values.email,
            password: values.plainPassword,
            type: values.type,
            branch: values.branch,
            phoneNumber: values.phoneNumber
        };
        dispatch(updateAdmin(payload, limits)).then(() => {
            setUpdateModal(false);
        });
    };

    const handleDeleteProblam = () => {
        dispatch(deleteAdmin(branchId, limits)).then(() => {
            deleteToggle();
            setMainPage(1);
        });
    };

    const handleSearch = (e) => {
        const newSearchQuery = e.target.value;
        setSearchQuery(newSearchQuery);
        const newSearchParams = {
            ...searchDefault,
            search: newSearchQuery || '',
            page: mainPage,
        };
        setSearchDefault(newSearchParams);
        const queryParams = new URLSearchParams(newSearchParams).toString();
        dispatch(searchAdmin(queryParams, newSearchParams.page));
    };

    // const ChangeMainPage = (selected) => {
    //     setMainPage(parseInt(selected.selected) + 1);
    // };

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
        const updatedSearchParams = {
            ...searchDefault,
            search: searchQuery,
            page: parseInt(selected.selected) + 1,
        };
        setSearchDefault(updatedSearchParams);
        const queryParams = new URLSearchParams(updatedSearchParams).toString();
        dispatch(searchAdmin(queryParams, updatedSearchParams.page));
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        getProblems?.adminGet?.data?.totalCount / postPerPage,
    );

    useEffect(() => {
        if (searchQuery) {
            const updatedSearchParams = { ...searchDefault, search: searchQuery, page: mainPage };
            const queryParams = new URLSearchParams(updatedSearchParams).toString();
            dispatch(searchAdmin(queryParams, updatedSearchParams.page));
        } else {
            dispatch(getAdmin(limits));
        }
        dispatch(allBranchDetail())
    }, [mainPage, rowsPerPage]);

    return (
        <>
            <div className="mt-[100px] d-flex justify-content-end">
                <div className="d-flex items-center gap-3">
                    <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2">
                        <IoSearchOutline />
                        <input
                            type="text"
                            name="search"
                            value={searchQuery}
                            onChange={handleSearch}
                            className="w-full outline-none"
                            placeholder="Search..."
                        />
                    </div>
                    <Button
                        onClick={toggle}
                        className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
                    >
                        <IoMdAdd className="mt-1 gap-1" />
                        Add Admin
                    </Button>
                </div>
            </div>
            <div className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between mt-5'>
                    <h3 className='fw-bold'>Admin User</h3>
                    <div>
                        Rows per page:
                        <select
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="ms-2 border rounded-md focus:outline-none"
                        >
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                        </select>
                    </div>
                </div>
                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Name</Th>
                                <Th>Email</Th>
                                <Th>Password</Th>
                                <Th>Phone Number</Th>
                                <Th>Type</Th>
                                <Th>Branch</Th>
                                <Th>Create By</Th>
                                <Th style={{ minWidth: '200px' }} className="text-end">Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {getProblems?.adminGet?.data?.AuthData?.length > 0 ? (
                                getProblems?.adminGet?.data?.AuthData?.map((res) => {
                                    return (
                                        <Tr key={res._id}>
                                            <Td>{res.name}</Td>
                                            <Td>{res.email}</Td>
                                            <Td>{res.plainPassword}</Td>
                                            <Td>{res.phoneNumber}</Td>
                                            <Td>
                                                {res.type?.toLowerCase() === 'admin'
                                                    ? 'Super Admin'
                                                    : res.type?.toLowerCase() === 'Manager'
                                                        ? 'Counsellor'
                                                        : res.type}
                                            </Td>
                                            <Td>{res.branch}</Td>
                                            <Td>{res?.manager_created_by?.name || '-'}</Td>
                                            <Td>
                                                <div className="d-flex gap-3 justify-end">
                                                    <FaEdit
                                                        onClick={() => {
                                                            updateToggle();
                                                            setFormData(res);
                                                            setBranchId(res._id);
                                                        }}
                                                        className="cursor-pointer border-green-color fs-5 text-success"
                                                        title="update"
                                                    />
                                                    <MdDelete
                                                        onClick={() => {
                                                            deleteToggle();
                                                            setBranchId(res._id);
                                                        }}
                                                        className="cursor-pointer border-green-color fs-5 text-danger"
                                                        title="delete"
                                                    />
                                                </div>
                                            </Td>
                                        </Tr>
                                    );
                                })
                            ) : (
                                <>
                                    <Tr>
                                        <Td colSpan={6} textAlign='center'>Admin Not Found</Td>
                                    </Tr>
                                </>
                            )}
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>

            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={ChangeMainPage}
                pageRangeDisplayed={5}
                pageCount={PageCount}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                className="pagination"
            />

            {/* add problem */}

            <Modal show={show} onHide={toggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Admin</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleAdminDetail}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>

                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('name', e.target.value)}
                                                value={values.name}
                                                placeholder="Enter Name"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="name"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('email', e.target.value)}
                                                value={values.email}
                                                placeholder="Enter Email"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="email"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="password"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('password', e.target.value)}
                                                value={values.password}
                                                placeholder="Enter Passsword"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="password"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Phone Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="phoneNumber"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('phoneNumber', e.target.value)}
                                                value={values.phoneNumber}
                                                placeholder="Enter Phone Number"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="phoneNumber"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>

                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Branch</Form.Label>
                                            <Form.Select
                                                type="text"
                                                name="branch"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('branch', e.target.value)}
                                                value={values.branch}
                                                className="shadow-none focus:!border-theme-dark"
                                            >
                                                <option value="">Select branch</option>
                                                {
                                                    getBranch?.allBranch?.data?.Branches?.map((res) => {
                                                        return (
                                                            <option value={res.branchName} key={res._id}>{res.branchName}</option>
                                                        )
                                                    })
                                                }

                                            </Form.Select>

                                            <ErrorMessage
                                                name="branch"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                // onClick={}
                                >
                                    Add
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* update problem */}

            <Modal show={updateModal} onHide={updateToggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Admin</Modal.Title>
                </Modal.Header>
                <Formik
                    enableReinitialize={true}  // This allows Formik to reset the initial values
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleUpadteProblam} // Formik will pass form values here
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('name', e.target.value)}
                                                value={values.name}
                                                placeholder="Enter Name"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="name"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="email"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('email', e.target.value)}
                                                value={values.email}
                                                placeholder="Enter Email"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="email"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="plainPassword"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('plainPassword', e.target.value)}
                                                value={values.plainPassword}
                                                placeholder="Enter Passsword"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="plainPassword"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Phone Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="phoneNumber"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('phoneNumber', e.target.value)}
                                                value={values.phoneNumber}
                                                placeholder="Enter Phone Number"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="phoneNumber"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Branch</Form.Label>
                                            <Form.Select
                                                type="text"
                                                name="branch"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('branch', e.target.value)}
                                                value={values.branch}
                                                className="shadow-none focus:!border-theme-dark"
                                            >
                                                <option value="">Select branch</option>
                                                {
                                                    getBranch?.allBranch?.data?.Branches?.map((res) => {
                                                        return (
                                                            <option value={res.branchName} key={res._id}>{res.branchName}</option>
                                                        )
                                                    })
                                                }

                                            </Form.Select>

                                            <ErrorMessage
                                                name="branch"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={updateToggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                // onClick={handleUpadteProblam}
                                >
                                    Update
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* delete problem */}

            <Modal show={deleteModal} onHide={deleteToggle}>
                <Modal.Body className='p-5'>
                    <div>
                        <PiWarningCircleBold className='text-7xl w-100 text-danger' />
                    </div>
                    <div className='text-center mt-4'>
                        <h3>Are You Sure ?</h3>
                        <p className='text-md'>Do you really want to delete these records?</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDeleteProblam}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
